( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-review-carousel', {
			direction: 'horizontal',
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 20,
			loop: false,

			breakpoints: {
				640: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 30,
				},
				1400: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 40,
				}
			},

			pagination: {
				el: '.js-review-carousel-pagination',
				type: 'progressbar',
			},

			navigation: {
				nextEl: '.js-review-carousel-nav .js-carousel-nav-next',
				prevEl: '.js-review-carousel-nav .js-carousel-nav-prev',
			},

			on: {
				afterInit: function(swiper) {
					const slideTotal = swiper.slides.length;
					const slidePerView = swiper.params['slidesPerView'];

					if ( slidePerView >= slideTotal) {
						$('.js-review-carousel-nav').hide();
					}
				}
			}
		});
	} );
} )( jQuery, document, window );
